<template>
    <div class="addcontract">
        <header class="text-xs-center white--text">
            <h2>Produktkategorie wählen</h2>
            <p>Wählen Sie über die Suche oder der Liste eine Versicherungsart aus:</p>

            <v-flex xs12 sm6 offset-sm3 mb-3>
                <v-text-field 
                  solo 
                  append-icon="search" 
                  v-model="searchfield" 
                  hint="Geben Sie die gesuchte Produktkategorie hier einfach ein ..."
                  persistent-hint
                  class="light-hint"
                  :loading="loading"
                ></v-text-field>
            </v-flex>
        </header>

        <section class="mb-3">
            <v-layout row>
                <v-flex xs12>
                    <v-card class="pl-2">
                        <v-list class="mobilelistfix" three-line>
                            <template v-for="(category_title, category_index) in product_categories">
                                <v-subheader class="mt-3" :key="category_index">{{ category_title=='Versicherung Selbständige' ? 'Versicherung für Selbstständige & Unternehmen' : category_title }}</v-subheader>

                                <v-divider :key="`d-${category_index}`" :inset="true"></v-divider>

                                <v-list-tile v-for="(item, index) in _.filter(insurances, ['category', category_title])" :key="`i-${category_index}-${index}`" avatar @click="doStep3(item)">
                                    <v-list-tile-avatar class="pt-3">
                                        <v-icon>{{ item.icon }}</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="item.name"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="item.description"></v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-btn icon><v-icon color="primary">navigate_next</v-icon></v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </template>
                            <template v-if="show_add_insurance">
                                <v-subheader>Unbekannt</v-subheader>
                                <v-divider :inset="true"></v-divider>
                                <v-list-tile class="unknownlisttile" @click="show_form_add_insurance = true; new_insurance = searchfield" avatar>
                                    <v-list-tile-avatar class="pt-3">
                                        <v-icon>add</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Produktkategorie nicht dabei?</v-list-tile-title>
                                        <v-list-tile-sub-title>Sie haben Ihre gesuchte Produktkategorie nicht gefunden? Dann fügen Sie diese einfach hier hinzu!</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>

        <v-bottom-sheet v-model="show_form_add_insurance" lazy inset>
            <v-card class="pa-3" tile>
                <v-form ref="form_add_insurance" lazy-validation @submit.prevent="add_insurance">
                    <v-layout row wrap justify-center>
                        <v-text-field
                            ref="new_insurance"
                            type="text"
                            v-model="new_insurance"
                            :rules="[() => !!new_insurance || 'Pflichtfeld - Bitte ausfüllen', () => !!new_insurance && new_insurance.length >= 3 || 'Die Produktkategorie muss aus mindestens 3 Zeichen bestehen']"
                            label="Produktkategorie *"
                            maxlength="36"
                            clearable
                            required
                        />
                    </v-layout>
                    <v-card-actions class="pa-0">
                        <v-btn flat color="secondary" @click="show_form_add_insurance = false">Abbrechen</v-btn>
                        <v-spacer />
                        <v-btn color="black" @click="add_insurance" dark>Hinzufügen und weiter</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-bottom-sheet>

        <v-dialog v-model="show_offerdialoge" absolute scrollable max-width="700">
            <v-card>
                <v-card-title class="headline">
                    <v-icon left>note_add</v-icon>
                    <span class="text-truncate">Angebot erhalten</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="show_offerdialoge = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="contract-overview-box inline-contractcard-box">
                    <v-card>
                        <v-layout>
                            <v-flex class="text-xs-center" xs2 sm3>
                                <v-avatar size="75px">
                                    <v-icon>{{ chosen_offerproduct.icon }}</v-icon>
                                </v-avatar>
                            </v-flex>
                            <v-flex xs10 sm9>
                                <v-card-title primary-title>
                                    <div class="w-100">
                                        <h3 class="headline text-truncate">{{ chosen_offerproduct.name }}</h3>
                                        <div class="pt-3">{{ chosen_offerproduct.description }}</div>
                                    </div>
                                </v-card-title>
                            </v-flex>
                        </v-layout>
                    </v-card>
                    <v-layout row wrap class="ma-3">
                        <v-flex id="onlinecalcInfobox" md5>
                            <p><v-icon left>plagiarism</v-icon><b>Vertrag vergleichen</b></p>
                            <ul class="pa-0">
                                <li><v-icon class="color-blue" left>check</v-icon>Vertrag wird von Ihrem Versicherer angefordert</li>
                                <li><v-icon class="color-blue" left>check</v-icon>Fachbereich erstellt Tarifvergleich auf Grundlage Ihrer Vertragsdaten</li>
                            </ul>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex md5 class="text-md-right">
                            <p><v-icon left>send</v-icon><b>Angebot zuschicken lassen</b></p>
                            <ul class="pa-0">
                                <li><v-icon class="color-blue" left>check</v-icon>individuelles Angebot erhalten</li>
                                <li><v-icon class="color-blue" left>check</v-icon>kostenfrei &amp; unverbindlich</li>
                                <li><v-icon class="color-blue" left>check</v-icon>persönlicher Fachberater</li>
                            </ul>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn v-if="productquestions.length==0 && chosen_offerproduct.id!=11 && chosen_offerproduct.id!=39" :to="`/check/add/company/${chosen_offerproduct.id}/${chosen_offerproduct.name}`" color="black" dark>Ihren Vertrag vergleichen</v-btn>
                    <v-spacer />
                    <v-btn v-if="chosen_offerproduct.thinksurance_id" color="blue" :href="`https://ts.finanzchecks.de/?productId=${chosen_offerproduct.thinksurance_id}`" target="_blank" dark>Zum Online-Rechner</v-btn>
                    <v-btn v-if="!chosen_offerproduct.thinksurance_id && chosen_offerproduct.url && chosen_offerproduct.is_iframed==0" color="blue" :href="producturl" target="_blank" dark>Zum Online-Rechner</v-btn>
                    <v-btn v-if="!chosen_offerproduct.thinksurance_id && chosen_offerproduct.url && chosen_offerproduct.is_iframed==1" color="primary" @click="show_offerdialoge_iframe=true" dark>Online-Rechner öffnen</v-btn>
                    <v-spacer />
                    <v-btn v-if="productquestions.length==0 && chosen_offerproduct.id!=11 && chosen_offerproduct.id!=39" color="black" :loading="productquestions_loading" @click="add_offer" dark>Angebot erhalten</v-btn>
                    <v-btn v-if="productquestions.length>0" color="black" :loading="productquestions_loading" @click="show_productquestiondialoge = true" dark>Wünsche angeben</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="show_offerdialoge_iframe" absolute max-width="1200">
            <v-card>
                <v-card-title class="headline hidden-xs-only">
                    <v-icon left>compare</v-icon>
                    <span class="text-truncate">Online-Vergleich von {{ chosen_offerproduct.name }}en</span>
                </v-card-title>
                <v-card-text>
                    <iframe id="offeriframe" :src="chosen_offerproduct.url"></iframe>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn flat @click="show_offerdialoge_iframe = false">Abbrechen</v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>


        <ProductQuestionsModal :show_dialoge.sync="show_productquestiondialoge" :product="chosen_offerproduct" :product_questions="productquestions" @questionsAnswered="add_offer" />

    </div>
</template>

<script>
import ProductQuestionsModal from '@/components/ProductQuestionsModal'


export default {
    data: () => ({
        type: 'company',
        searchfield: '',
        insurances: [],
        show_form_add_insurance: false,
        show_add_insurance: true,
        new_insurance: '',
        show_offerdialoge: false,
        chosen_offerproduct: {id:null, name: null},
        show_offerdialoge_iframe: false,
        product_categories: [],
        loading: true,
        show_productquestiondialoge: false,
        productquestions: [],
        productquestions_loading: false
    }),
    
    components: {
        ProductQuestionsModal
    },

    computed: {
        producturl(){
            let url = this.chosen_offerproduct.url;
            if(url.indexOf("?") < 0){
                url += '?';
            }else{
                url += '&';
            }
            return url+'utms=vapp&uid='+this.$store.state.auth.fb.uid;
        }
    },

    watch: {
        searchfield (search_value) {
            this.insurances = this.$store.getters['products/getAllProducts'];
            if(search_value.length>1){
                this.insurances = this.customFilter(this.insurances, search_value);
            }
        },

        show_offerdialoge(val){
            if(!val){
                // this.$router.go(-1);
                this.$router.push({ path: `./` });
            }
        }
    },


    mounted: function () {
        this.type = this.$route.params.type ? this.$route.params.type : 'company';
        if(this.type){
            if(this.type=='company'){
                this.product_categories = ['Versicherung Selbständige', 'Altersvorsorge', 'Lebensversicherung', 'Krankenkasse'];
            }else{
                this.product_categories = ['Private Versicherung', 'Private Krankenversicherung', 'Altersvorsorge', 'Lebensversicherung', 'Krankenkasse'];
            }
            this.insurances = this.$store.getters['products/getAllProducts'];
            if(this.insurances.length<5){
                this.$store.dispatch('products/loadProductData').then(products => {
                    this.insurances = products;
                    this.loading = false;
                    this.getPreChosenProduct();
                });
            }else{
                this.loading = false;
                this.getPreChosenProduct();
            }
        };
        if(this.$route.params.show_offer_dialog){
            if(this.$route.params.show_offer_dialog==1){
                this.getPreChosenProduct();
            }
        }
    },

    methods: {
        getPreChosenProduct(){
            if(this.$route.params.product_id){
                let prechose_product = this.$store.getters['products/getProductFromID'](this.$route.params.product_id);
                if(prechose_product){
                    this.doStep3(prechose_product);
                }
            };
        },

        customFilter(objList, search_value){
            if(search_value === undefined || search_value === '' ){
                return objList;
            }
            let filteredProducts = objList.filter(product => {
                let flag;
                for(let prop in product){
                    flag = false;
                    if(product[prop]==null){
                        break;
                    }
                    flag = product[prop].toString().search(new RegExp(search_value, "i")) > -1;
                    if(flag){
                        break;
                    }
                }
                return flag;
            });
            return filteredProducts;
        },

        add_insurance(){
            let new_product = {id:0,name:this.new_insurance,category:'Versicherung Selbständige'};
            this.show_form_add_insurance = false;
            this.show_add_insurance = false;
            if(this.$route.fullPath.search('offer')>0){
                this.$store.dispatch('chat/sendAdminMail', {
                    subject: `Produkt nicht gefunden vom Kunden: ${this.$store.getters['user/getDisplayName'](false)}`,
                    content1: `${this.$store.getters['user/getDisplayName']()} wünscht sich ein Angebot für das Produkt: "${new_product.name}". Dieses wurde vom Kunden händisch angelegt, da dieses scheinbar nicht in unseren Produktportfolio vorgefunden werden konnte.`,
                    kind: `UNKNOWN_PRODUCT`,
                    heading: `Unbekanntes Produkt: ${new_product.name}`
                });
            };
            this.doStep3(new_product);
        },

        add_offer(productquesion_answers = null){
            // console.log('add_offer :>> ', productquesion_answers);
            this.$store.dispatch('contracts/addContract', {
                kind: this.chosen_offerproduct.name,
                product_id: this.chosen_offerproduct.id=='0' ? null : this.chosen_offerproduct.id,
                product: this.chosen_offerproduct,
                type: this.type,
                contract_status_id: 2,  // 'Angebot angefragt'
                color: 'blue',
                status: 'Angebot angefragt',
                is_mandate: 1,
                bestand: 'Eigen',
                productpartner: {},
                productquesion_answers
            }).then(() => {
                this.$snotify.success('Angebot wurde erfolgreich angefragt');
                this.$router.push({ path: '/contract/all' });
            });
        },

        doStep3(item){
            if(this.$route.fullPath.search('offer')<0){
                this.$router.push({ path: `./${this.type}/${item.id}/${encodeURI(item.name)}` });
            }else{
                this.show_offerdialoge = true;
                this.productquestions_loading = true;
                this.productquestions = [];
                this.chosen_offerproduct = item;
                this.$store.dispatch('products/loadProductQuestions', this.chosen_offerproduct.id).then(response => {
                    if(response){
                        this.productquestions = response;
                        if(this.$route.params.action === 'wishes'){
                            this.show_productquestiondialoge = true
                        }
                    };
                }).finally(() => {
                    this.productquestions_loading = false;
                })
            }
        }
    }
}
</script>


<style scoped>
    #offeriframe{
        width:100%;
        height:80vh;
        border:0;
    }

    @media screen and (max-width: 960px) {
        .layout.row.wrap > div:last-child {
            margin-top: 2rem;
        }
    }

    @media screen and (max-width: 768px) {
        #onlinecalcInfobox{
            margin-top: 1.5rem;
        }
        .contract-overview-box>div>div.layout{
            flex-direction: column;
            text-align: center;
        }
        .contract-overview-box>div>div.layout>.flex{
            max-width: 100%;
            flex-basis: 100%;
        }
        .contract-overview-box .v-avatar .v-icon{
            font-size: 4rem;
        }
        .mobilelistfix .v-list__tile{
          font-size: 14px;
          height: auto;
          border-bottom: 1px solid rgba(0,0,0,.1);
          padding: 10px 16px;
        }
        .mobilelistfix .v-list__tile .v-list__tile__avatar{
          min-width: 40px;
        }
        .mobilelistfix .v-list__tile .v-list__tile__avatar .v-avatar>.v-icon{
          font-size: 2.5rem;
          margin-left: -1rem;
        }
        .mobilelistfix .v-list__tile .v-list__tile__action {
          min-width: 2.5rem;
          margin-right: -1rem;
        }
        .mobilelistfix .v-list__tile .v-list__tile__sub-title {
          max-height: initial;
          overflow: initial;
          display: block;
          margin-bottom: .5rem;
        }
    }
</style>